import { Fragment } from "react";
import type { Point } from "@cs2/contracts";
import type { WalkingPathAction } from "@cs2/physics";
import { Circle, Group, Path } from "react-konva";
import { mapThemeColor, overlay } from "../lib/map-style.js";
import { movementGlyphs, movementGlyphViewBox } from "../lib/movement-paths.js";

/**
 * Markiert auf dem Laufweg, wo eine Aktion beginnt (Sprung, Crouch-Jump,
 * Drop, Leiter) — Editor und Quickview zeichnen denselben Baustein.
 */
export function RouteActionMarkers({
  points,
  actions,
  sx,
  sy,
  scale,
  opacity = 1,
}: {
  points: readonly Point[];
  actions: readonly WalkingPathAction[];
  sx: number;
  sy: number;
  scale: number;
  opacity?: number;
}) {
  const radius = overlay.routeAction.radius * scale;
  const glyph = overlay.routeAction.glyph * scale;
  const glyphScale = glyph / movementGlyphViewBox;
  const color = mapThemeColor("--route");
  return (
    <Fragment>
      {actions.map((action) => {
        const point = points[action.pointIndex];
        if (!point) return null;
        return (
          <Group
            key={`${action.kind}-${action.pointIndex}`}
            x={point.x * sx}
            y={point.y * sy}
            opacity={opacity}
            listening={false}
          >
            <Circle
              radius={radius}
              fill={mapThemeColor("--bg")}
              stroke={color}
              strokeWidth={overlay.routeAction.stroke * scale}
            />
            <Path
              data={movementGlyphs[action.kind]}
              x={-glyph / 2}
              y={-glyph / 2}
              scaleX={glyphScale}
              scaleY={glyphScale}
              stroke={color}
              strokeWidth={2.4}
              lineCap="round"
              lineJoin="round"
            />
          </Group>
        );
      })}
    </Fragment>
  );
}
